import { RoleApiInterface, UserApiInterface } from "@core/interfaces/user-api-interface";
import { RoleInterface, UserInterface } from "@core/interfaces/user-interface";
import { BaseConfig } from "@domain/helpers/base-config";
import { UserApiInterface as UserApiInterfaceDomain } from "@domain/interfaces/user/user-api-interface";

export const userAdapter = (apiResponse: UserApiInterface): UserInterface => {
    const { accessToken, refreshToken, tokenType, user: userData } = apiResponse;
    
    const objSend: UserInterface = {
        id: userData.id,
        username: userData.username,
        email: userData.email,
        roles: BaseConfig.mapAdapter( userData.roles, roleAdapter ),
        accessToken: accessToken,
        refreshToken: refreshToken,
        tokenType
    }
    
    return objSend;
}

export const userAdapterApi = (apiResponse: UserApiInterfaceDomain): UserInterface => {
    const { id, username, email, roles, es_activo } = apiResponse;
    
    const objSend: UserInterface = {
        id: id.toString(),
        username:username,
        email:email,
        roles: BaseConfig.mapAdapter( roles, roleAdapter ),
        accessToken: '',
        refreshToken: '',
        tokenType: ''
    }
    
    return objSend;
}

export const roleAdapter = (role: RoleApiInterface): RoleInterface => {
    const { id, nombre, descripcion } = role;
    
    const objSend: RoleInterface = {
        id,
        name: nombre,
        description: descripcion,
    }
    
    return objSend;
}